// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Minimal Design CSS Variables */
:root {
  --primary-color: #1e3a8a;
  --primary-hover: #1e40af;
  --secondary-color: #f8fafc;
  --success-color: #059669;
  --warning-color: #d97706;
  --danger-color: #dc2626;
  --text-primary: #1f2937;
  --text-secondary: #6b7280;
  --border-color: #e5e7eb;
  --shadow-sm: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --shadow-md: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --shadow-lg: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --radius: 6px;
  --radius-lg: 8px;
}

/* Layout */
.credit-mgmt-grid {
  display: grid;
  grid-template-columns: 1.5fr 1fr;
  gap: 2rem;
  padding: 1.5rem;
  max-width: 1400px;
  margin: 0 auto;
  min-height: 100vh;
  background: #fafbfc;
}

@media (max-width: 1024px) {
  .credit-mgmt-grid {
    grid-template-columns: 1fr;
    gap: 1rem;
    padding: 1rem;
  }
}

.left-pane,
.right-pane .card {
  background: white;
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-sm);
  border: 1px solid var(--border-color);
  transition: box-shadow 0.2s ease;
}

.left-pane:hover,
.right-pane .card:hover {
  box-shadow: var(--shadow-md);
}

.card {
  padding: 1.5rem;
  margin-bottom: 1rem;
}

.pane-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid var(--border-color);
}

.pane-header h2 {
  color: var(--text-primary);
  font-size: 1.25rem;
  font-weight: 600;
  margin: 0;
}

/* Enhanced Search Controls */
.search-controls {
  background: var(--secondary-color);
  border: 1px solid var(--border-color);
  border-radius: var(--radius);
  padding: 1rem;
  margin-bottom: 1.5rem;
}

.search-controls input {
  border: 1px solid var(--border-color);
  border-radius: var(--radius);
  padding: 0.5rem;
  font-size: 0.875rem;
  transition: all 0.2s ease;
  background: white;
}

.search-controls input:focus {
  outline: none;
  border-color: var(--primary-color);
  box-shadow: 0 0 0 3px rgb(37 99 235 / 0.1);
}

/* Table Enhancements */
.org-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 1rem;
  background: white;
  border-radius: var(--radius);
  overflow: hidden;
  border: 1px solid var(--border-color);
}

.org-table th {
  background: var(--text-primary);
  color: white;
  padding: 0.75rem;
  text-align: left;
  font-weight: 600;
  font-size: 0.875rem;
}

.org-table td {
  padding: 0.75rem;
  text-align: left;
  border-bottom: 1px solid var(--border-color);
  vertical-align: middle;
}

.org-table tbody tr {
  transition: background-color 0.2s ease;
  cursor: pointer;
}

.org-table tbody tr:hover {
  background: var(--secondary-color);
}

.active-row {
  background: #eff6ff !important;
  border-left: 3px solid var(--primary-color);
}

.user-row td {
  background: #fafbfc;
  border-top: none;
}

/* Buttons */
.primary {
  background: var(--primary-color);
  border: none;
  color: white;
  padding: 0.5rem 1rem;
  font-size: 0.875rem;
  font-weight: 500;
  border-radius: var(--radius);
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: var(--shadow-sm);
}

.primary:hover:not(:disabled) {
  background: var(--primary-hover);
  box-shadow: var(--shadow-md);
}

.primary:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.secondary {
  background: white;
  border: 1px solid var(--border-color);
  color: var(--text-primary);
  padding: 0.5rem 1rem;
  font-size: 0.875rem;
  font-weight: 500;
  border-radius: var(--radius);
  cursor: pointer;
  transition: all 0.2s ease;
}

.secondary:hover:not(:disabled) {
  background: var(--secondary-color);
  border-color: var(--text-secondary);
}

.warning {
  background: var(--warning-color);
}

.warning:hover:not(:disabled) {
  background: #b45309;
}

button.small {
  padding: 0.25rem 0.5rem;
  font-size: 0.75rem;
  border-radius: calc(var(--radius) * 0.75);
}

button.danger {
  background: var(--danger-color);
  color: white;
  border: none;
  transition: all 0.2s ease;
}

button.danger:hover:not(:disabled) {
  background: #b91c1c;
}

button.danger.secondary {
  background: white;
  color: var(--danger-color);
  border: 1px solid var(--danger-color);
}

button.danger.secondary:hover:not(:disabled) {
  background: var(--danger-color);
  color: white;
}

.edit-btn {
  background: transparent;
  border: 1px solid var(--border-color);
  color: var(--text-secondary);
  padding: 0.125rem 0.375rem;
  font-size: 0.75rem;
  border-radius: calc(var(--radius) * 0.5);
  cursor: pointer;
  transition: all 0.2s ease;
}

.edit-btn:hover {
  background: var(--secondary-color);
  color: var(--text-primary);
}

/* Enhanced Badges */
.badge {
  display: inline-flex;
  align-items: center;
  padding: 0.25rem 0.5rem;
  border-radius: 9999px;
  font-size: 0.75rem;
  font-weight: 600;
  color: white;
  background: var(--success-color);
}

.badge.green {
  background: var(--success-color);
}

.badge.warning {
  background: var(--warning-color);
}

/* Enhanced Forms */
form {
  space-y: 1rem;
}

form label {
  display: flex;
  flex-direction: column;
  margin-bottom: 1rem;
  font-size: 0.875rem;
  font-weight: 500;
  color: var(--text-primary);
}

form input,
form select {
  padding: 0.5rem;
  border: 1px solid var(--border-color);
  border-radius: var(--radius);
  font-size: 0.875rem;
  transition: all 0.2s ease;
  background: white;
  margin-top: 0.25rem;
}

form input:focus,
form select:focus {
  outline: none;
  border-color: var(--primary-color);
  box-shadow: 0 0 0 3px rgb(37 99 235 / 0.1);
}

form input:invalid {
  border-color: var(--danger-color);
}

/* Enhanced Spinner */
.spinner {
  border: 3px solid #e5e7eb;
  border-top: 3px solid var(--primary-color);
  border-radius: 50%;
  width: 1.5rem;
  height: 1.5rem;
  animation: spin 1s linear infinite;
  margin: 2rem auto;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

/* Toast Notifications */
.toast-container {
  position: fixed;
  top: 1rem;
  right: 1rem;
  z-index: 1000;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.toast {
  background: white;
  border: 1px solid var(--border-color);
  border-radius: var(--radius);
  padding: 0.75rem;
  box-shadow: var(--shadow-lg);
  display: flex;
  align-items: center;
  gap: 0.5rem;
  min-width: 300px;
  animation: slideIn 0.3s ease;
}

.toast.success {
  border-left: 4px solid var(--success-color);
}

.toast.error {
  border-left: 4px solid var(--danger-color);
}

.toast.warning {
  border-left: 4px solid var(--warning-color);
}

@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateX(100%);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

/* Status Indicators */
.status-indicator {
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  padding: 0.125rem 0.5rem;
  border-radius: 9999px;
  font-size: 0.75rem;
  font-weight: 500;
}

.status-indicator.active {
  background: #dcfce7;
  color: #166534;
}

.status-indicator.trial {
  background: #fef3c7;
  color: #92400e;
}

.status-indicator.expired {
  background: #fef2f2;
  color: #dc2626;
}

/* Enhanced Details/Summary */
details.card {
  border: 1px solid var(--border-color);
  transition: all 0.2s ease;
}

details.card:hover {
  border-color: var(--primary-color);
}

details summary {
  cursor: pointer;
  font-weight: 600;
  color: var(--text-primary);
  padding: 0.75rem 0;
  border-bottom: 1px solid var(--border-color);
  transition: color 0.2s ease;
}

details summary:hover {
  color: var(--primary-color);
}

details[open] summary {
  color: var(--primary-color);
  border-bottom-color: var(--primary-color);
}

/* Selected Organization Indicator */
.selected-org-info {
  background: #eff6ff;
  border: 1px solid #bfdbfe;
  border-radius: var(--radius);
  padding: 0.75rem;
  margin-bottom: 1rem;
  font-size: 0.875rem;
  color: var(--text-primary);
}

/* User Tags */
.user-tag {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.375rem 0.5rem;
  background: white;
  border: 1px solid var(--border-color);
  border-radius: var(--radius);
  font-size: 0.8rem;
  transition: all 0.2s ease;
  box-shadow: var(--shadow-sm);
}

.user-tag:hover {
  box-shadow: var(--shadow-md);
}

.user-tag.owner-tag {
  background: linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%);
  border: 2px solid #1e3a8a;
  box-shadow: 0 2px 8px rgba(30, 58, 138, 0.3);
}

.user-tag.owner-tag:hover {
  box-shadow: 0 4px 12px rgba(30, 58, 138, 0.4);
}

.user-tag .role {
  background: var(--secondary-color);
  color: var(--text-secondary);
  padding: 0.125rem 0.375rem;
  border-radius: calc(var(--radius) * 0.5);
  font-size: 0.7rem;
  font-weight: 500;
}

.user-tag .role.owner-role {
  background: linear-gradient(135deg, #1e3a8a 0%, #1e40af 100%);
  color: white;
  font-weight: 700;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
  animation: subtle-pulse 2s ease-in-out infinite;
}

@keyframes subtle-pulse {
  0%, 100% { transform: scale(1); }
  50% { transform: scale(1.05); }
}

/* Pagination */
.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
  margin-top: 1.5rem;
  padding: 1rem;
  background: var(--secondary-color);
  border-radius: var(--radius);
}

.pagination button {
  padding: 0.375rem 0.75rem;
  border: 1px solid var(--border-color);
  background: white;
  border-radius: var(--radius);
  font-size: 0.875rem;
  cursor: pointer;
  transition: all 0.2s ease;
}

.pagination button:hover:not(:disabled) {
  background: var(--primary-color);
  color: white;
  border-color: var(--primary-color);
}

.pagination button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* CTA Button */
.cta-add-org {
  display: block;
  width: 100%;
  margin-bottom: 1.5rem;
  font-size: 0.875rem;
  padding: 0.75rem;
  background: var(--success-color);
  border: none;
  color: white;
  border-radius: var(--radius);
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: var(--shadow-sm);
}

.cta-add-org:hover {
  background: #047857;
  box-shadow: var(--shadow-md);
}

/* Edit Name Inline */
.edit-name-container {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.edit-name-input {
  flex: 1 1;
  padding: 0.25rem 0.5rem;
  border: 1px solid var(--primary-color);
  border-radius: var(--radius);
  font-size: 0.875rem;
}

.edit-name-input:focus {
  outline: none;
  box-shadow: 0 0 0 2px rgb(37 99 235 / 0.2);
}

/* Responsive Design */
@media (max-width: 768px) {
  .search-controls > div {
    flex-direction: column;
  }
  
  .org-table th,
  .org-table td {
    padding: 0.5rem;
    font-size: 0.8rem;
  }
  
  .user-tag {
    font-size: 0.75rem;
    padding: 0.25rem 0.375rem;
  }
  
  .toast {
    min-width: 250px;
    margin: 0 1rem;
  }
}

/* Animations */
@keyframes fadeIn {
  from { opacity: 0; transform: translateY(10px); }
  to { opacity: 1; transform: translateY(0); }
}

.fade-in {
  animation: fadeIn 0.3s ease;
}

/* Focus Visible for Accessibility */
button:focus-visible,
input:focus-visible,
select:focus-visible {
  outline: 2px solid var(--primary-color);
  outline-offset: 2px;
}

/* Searchable Select Component */
.searchable-select {
  position: relative;
  width: 100%;
}

.select-trigger {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.5rem;
  border: 1px solid var(--border-color);
  border-radius: var(--radius);
  background: white;
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 0.875rem;
}

.select-trigger:hover:not(.disabled) {
  border-color: var(--text-secondary);
}

.select-trigger:focus {
  outline: none;
  border-color: var(--primary-color);
  box-shadow: 0 0 0 3px rgb(37 99 235 / 0.1);
}

.select-trigger.open {
  border-color: var(--primary-color);
  box-shadow: 0 0 0 3px rgb(37 99 235 / 0.1);
}

.select-trigger.disabled {
  background: var(--secondary-color);
  color: var(--text-secondary);
  cursor: not-allowed;
}

.select-value {
  flex: 1 1;
  text-align: left;
  color: var(--text-primary);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.select-trigger.disabled .select-value {
  color: var(--text-secondary);
}

.select-arrow {
  color: var(--text-secondary);
  font-size: 0.75rem;
  transition: transform 0.2s ease;
  margin-left: 0.5rem;
}

.select-trigger.open .select-arrow {
  transform: rotate(180deg);
}

.select-dropdown {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  z-index: 1000;
  background: white;
  border: 1px solid var(--border-color);
  border-radius: var(--radius);
  box-shadow: var(--shadow-lg);
  margin-top: 0.25rem;
  overflow: hidden;
}

.select-search {
  width: 100%;
  padding: 0.5rem;
  border: none;
  border-bottom: 1px solid var(--border-color);
  font-size: 0.875rem;
  outline: none;
}

.select-search:focus {
  border-bottom-color: var(--primary-color);
}

.select-options {
  max-height: 200px;
  overflow-y: auto;
}

.select-option {
  padding: 0.5rem;
  cursor: pointer;
  transition: background-color 0.15s ease;
  font-size: 0.875rem;
  border-bottom: 1px solid var(--border-color);
}

.select-option:last-child {
  border-bottom: none;
}

.select-option:hover,
.select-option.highlighted {
  background: var(--secondary-color);
}

.select-option.selected {
  background: #eff6ff;
  color: var(--primary-color);
  font-weight: 500;
}

.select-option.no-options {
  color: var(--text-secondary);
  cursor: default;
  font-style: italic;
}

.select-option.no-options:hover {
  background: transparent;
}

/* Custom scrollbar for select options */
.select-options::-webkit-scrollbar {
  width: 6px;
}

.select-options::-webkit-scrollbar-track {
  background: var(--secondary-color);
}

.select-options::-webkit-scrollbar-thumb {
  background: var(--border-color);
  border-radius: 3px;
}

.select-options::-webkit-scrollbar-thumb:hover {
  background: var(--text-secondary);
}

/* Responsive adjustments for mobile */
@media (max-width: 768px) {
  .select-dropdown {
    position: fixed;
    left: 1rem;
    right: 1rem;
    top: auto;
    bottom: auto;
    max-height: 50vh;
  }
  
  .select-options {
    max-height: 40vh;
  }
} `, "",{"version":3,"sources":["webpack://./src/pages/css/CreditManagement.css"],"names":[],"mappings":"AAAA,iCAAiC;AACjC;EACE,wBAAwB;EACxB,wBAAwB;EACxB,0BAA0B;EAC1B,wBAAwB;EACxB,wBAAwB;EACxB,uBAAuB;EACvB,uBAAuB;EACvB,yBAAyB;EACzB,uBAAuB;EACvB,0CAA0C;EAC1C,6EAA6E;EAC7E,+EAA+E;EAC/E,aAAa;EACb,gBAAgB;AAClB;;AAEA,WAAW;AACX;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE;IACE,0BAA0B;IAC1B,SAAS;IACT,aAAa;EACf;AACF;;AAEA;;EAEE,iBAAiB;EACjB,+BAA+B;EAC/B,4BAA4B;EAC5B,qCAAqC;EACrC,gCAAgC;AAClC;;AAEA;;EAEE,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,qBAAqB;EACrB,oBAAoB;EACpB,4CAA4C;AAC9C;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;EAChB,SAAS;AACX;;AAEA,6BAA6B;AAC7B;EACE,kCAAkC;EAClC,qCAAqC;EACrC,4BAA4B;EAC5B,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,qCAAqC;EACrC,4BAA4B;EAC5B,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,0CAA0C;AAC5C;;AAEA,uBAAuB;AACvB;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;EAChB,iBAAiB;EACjB,4BAA4B;EAC5B,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;EACE,+BAA+B;EAC/B,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,4CAA4C;EAC5C,sBAAsB;AACxB;;AAEA;EACE,sCAAsC;EACtC,eAAe;AACjB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,8BAA8B;EAC9B,2CAA2C;AAC7C;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,YAAY;AACZ;EACE,gCAAgC;EAChC,YAAY;EACZ,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,4BAA4B;EAC5B,eAAe;EACf,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,gCAAgC;EAChC,4BAA4B;AAC9B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,qCAAqC;EACrC,0BAA0B;EAC1B,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,4BAA4B;EAC5B,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,kCAAkC;EAClC,mCAAmC;AACrC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,+BAA+B;EAC/B,YAAY;EACZ,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,0BAA0B;EAC1B,qCAAqC;AACvC;;AAEA;EACE,+BAA+B;EAC/B,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,qCAAqC;EACrC,4BAA4B;EAC5B,0BAA0B;EAC1B,kBAAkB;EAClB,wCAAwC;EACxC,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,kCAAkC;EAClC,0BAA0B;AAC5B;;AAEA,oBAAoB;AACpB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA,mBAAmB;AACnB;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;;EAEE,eAAe;EACf,qCAAqC;EACrC,4BAA4B;EAC5B,mBAAmB;EACnB,yBAAyB;EACzB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;;EAEE,aAAa;EACb,kCAAkC;EAClC,0CAA0C;AAC5C;;AAEA;EACE,iCAAiC;AACnC;;AAEA,qBAAqB;AACrB;EACE,yBAAyB;EACzB,0CAA0C;EAC1C,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,kCAAkC;EAClC,iBAAiB;AACnB;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA,wBAAwB;AACxB;EACE,eAAe;EACf,SAAS;EACT,WAAW;EACX,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,qCAAqC;EACrC,4BAA4B;EAC5B,gBAAgB;EAChB,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,sBAAsB;AACtB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,wBAAwB;EACxB,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,6BAA6B;AAC7B;EACE,qCAAqC;EACrC,yBAAyB;AAC3B;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;EAClB,4CAA4C;EAC5C,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA,oCAAoC;AACpC;EACE,mBAAmB;EACnB,yBAAyB;EACzB,4BAA4B;EAC5B,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA,cAAc;AACd;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,wBAAwB;EACxB,iBAAiB;EACjB,qCAAqC;EACrC,4BAA4B;EAC5B,iBAAiB;EACjB,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,6DAA6D;EAC7D,yBAAyB;EACzB,4CAA4C;AAC9C;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,kCAAkC;EAClC,4BAA4B;EAC5B,0BAA0B;EAC1B,wCAAwC;EACxC,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,gBAAgB;EAChB,yCAAyC;EACzC,+CAA+C;AACjD;;AAEA;EACE,WAAW,mBAAmB,EAAE;EAChC,MAAM,sBAAsB,EAAE;AAChC;;AAEA,eAAe;AACf;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,kCAAkC;EAClC,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;EACzB,qCAAqC;EACrC,iBAAiB;EACjB,4BAA4B;EAC5B,mBAAmB;EACnB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;EAChC,YAAY;EACZ,kCAAkC;AACpC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,eAAe;AACf;EACE,cAAc;EACd,WAAW;EACX,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;EAChB,gCAAgC;EAChC,YAAY;EACZ,YAAY;EACZ,4BAA4B;EAC5B,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,SAAO;EACP,uBAAuB;EACvB,sCAAsC;EACtC,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,0CAA0C;AAC5C;;AAEA,sBAAsB;AACtB;EACE;IACE,sBAAsB;EACxB;;EAEA;;IAEE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,yBAAyB;EAC3B;;EAEA;IACE,gBAAgB;IAChB,cAAc;EAChB;AACF;;AAEA,eAAe;AACf;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,oCAAoC;AACpC;;;EAGE,uCAAuC;EACvC,mBAAmB;AACrB;;AAEA,gCAAgC;AAChC;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,qCAAqC;EACrC,4BAA4B;EAC5B,iBAAiB;EACjB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,0CAA0C;AAC5C;;AAEA;EACE,kCAAkC;EAClC,0CAA0C;AAC5C;;AAEA;EACE,kCAAkC;EAClC,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,0BAA0B;EAC1B,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;EAClB,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,aAAa;EACb,iBAAiB;EACjB,qCAAqC;EACrC,4BAA4B;EAC5B,4BAA4B;EAC5B,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,YAAY;EACZ,4CAA4C;EAC5C,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,uCAAuC;EACvC,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,kCAAkC;AACpC;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;AACzB;;AAEA,wCAAwC;AACxC;EACE,UAAU;AACZ;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;AACnC;;AAEA,sCAAsC;AACtC;EACE;IACE,eAAe;IACf,UAAU;IACV,WAAW;IACX,SAAS;IACT,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;AACF","sourcesContent":["/* Minimal Design CSS Variables */\n:root {\n  --primary-color: #1e3a8a;\n  --primary-hover: #1e40af;\n  --secondary-color: #f8fafc;\n  --success-color: #059669;\n  --warning-color: #d97706;\n  --danger-color: #dc2626;\n  --text-primary: #1f2937;\n  --text-secondary: #6b7280;\n  --border-color: #e5e7eb;\n  --shadow-sm: 0 1px 2px 0 rgb(0 0 0 / 0.05);\n  --shadow-md: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);\n  --shadow-lg: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);\n  --radius: 6px;\n  --radius-lg: 8px;\n}\n\n/* Layout */\n.credit-mgmt-grid {\n  display: grid;\n  grid-template-columns: 1.5fr 1fr;\n  gap: 2rem;\n  padding: 1.5rem;\n  max-width: 1400px;\n  margin: 0 auto;\n  min-height: 100vh;\n  background: #fafbfc;\n}\n\n@media (max-width: 1024px) {\n  .credit-mgmt-grid {\n    grid-template-columns: 1fr;\n    gap: 1rem;\n    padding: 1rem;\n  }\n}\n\n.left-pane,\n.right-pane .card {\n  background: white;\n  border-radius: var(--radius-lg);\n  box-shadow: var(--shadow-sm);\n  border: 1px solid var(--border-color);\n  transition: box-shadow 0.2s ease;\n}\n\n.left-pane:hover,\n.right-pane .card:hover {\n  box-shadow: var(--shadow-md);\n}\n\n.card {\n  padding: 1.5rem;\n  margin-bottom: 1rem;\n}\n\n.pane-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 1.5rem;\n  padding-bottom: 1rem;\n  border-bottom: 1px solid var(--border-color);\n}\n\n.pane-header h2 {\n  color: var(--text-primary);\n  font-size: 1.25rem;\n  font-weight: 600;\n  margin: 0;\n}\n\n/* Enhanced Search Controls */\n.search-controls {\n  background: var(--secondary-color);\n  border: 1px solid var(--border-color);\n  border-radius: var(--radius);\n  padding: 1rem;\n  margin-bottom: 1.5rem;\n}\n\n.search-controls input {\n  border: 1px solid var(--border-color);\n  border-radius: var(--radius);\n  padding: 0.5rem;\n  font-size: 0.875rem;\n  transition: all 0.2s ease;\n  background: white;\n}\n\n.search-controls input:focus {\n  outline: none;\n  border-color: var(--primary-color);\n  box-shadow: 0 0 0 3px rgb(37 99 235 / 0.1);\n}\n\n/* Table Enhancements */\n.org-table {\n  width: 100%;\n  border-collapse: collapse;\n  margin-top: 1rem;\n  background: white;\n  border-radius: var(--radius);\n  overflow: hidden;\n  border: 1px solid var(--border-color);\n}\n\n.org-table th {\n  background: var(--text-primary);\n  color: white;\n  padding: 0.75rem;\n  text-align: left;\n  font-weight: 600;\n  font-size: 0.875rem;\n}\n\n.org-table td {\n  padding: 0.75rem;\n  text-align: left;\n  border-bottom: 1px solid var(--border-color);\n  vertical-align: middle;\n}\n\n.org-table tbody tr {\n  transition: background-color 0.2s ease;\n  cursor: pointer;\n}\n\n.org-table tbody tr:hover {\n  background: var(--secondary-color);\n}\n\n.active-row {\n  background: #eff6ff !important;\n  border-left: 3px solid var(--primary-color);\n}\n\n.user-row td {\n  background: #fafbfc;\n  border-top: none;\n}\n\n/* Buttons */\n.primary {\n  background: var(--primary-color);\n  border: none;\n  color: white;\n  padding: 0.5rem 1rem;\n  font-size: 0.875rem;\n  font-weight: 500;\n  border-radius: var(--radius);\n  cursor: pointer;\n  transition: all 0.2s ease;\n  box-shadow: var(--shadow-sm);\n}\n\n.primary:hover:not(:disabled) {\n  background: var(--primary-hover);\n  box-shadow: var(--shadow-md);\n}\n\n.primary:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.secondary {\n  background: white;\n  border: 1px solid var(--border-color);\n  color: var(--text-primary);\n  padding: 0.5rem 1rem;\n  font-size: 0.875rem;\n  font-weight: 500;\n  border-radius: var(--radius);\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.secondary:hover:not(:disabled) {\n  background: var(--secondary-color);\n  border-color: var(--text-secondary);\n}\n\n.warning {\n  background: var(--warning-color);\n}\n\n.warning:hover:not(:disabled) {\n  background: #b45309;\n}\n\nbutton.small {\n  padding: 0.25rem 0.5rem;\n  font-size: 0.75rem;\n  border-radius: calc(var(--radius) * 0.75);\n}\n\nbutton.danger {\n  background: var(--danger-color);\n  color: white;\n  border: none;\n  transition: all 0.2s ease;\n}\n\nbutton.danger:hover:not(:disabled) {\n  background: #b91c1c;\n}\n\nbutton.danger.secondary {\n  background: white;\n  color: var(--danger-color);\n  border: 1px solid var(--danger-color);\n}\n\nbutton.danger.secondary:hover:not(:disabled) {\n  background: var(--danger-color);\n  color: white;\n}\n\n.edit-btn {\n  background: transparent;\n  border: 1px solid var(--border-color);\n  color: var(--text-secondary);\n  padding: 0.125rem 0.375rem;\n  font-size: 0.75rem;\n  border-radius: calc(var(--radius) * 0.5);\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.edit-btn:hover {\n  background: var(--secondary-color);\n  color: var(--text-primary);\n}\n\n/* Enhanced Badges */\n.badge {\n  display: inline-flex;\n  align-items: center;\n  padding: 0.25rem 0.5rem;\n  border-radius: 9999px;\n  font-size: 0.75rem;\n  font-weight: 600;\n  color: white;\n  background: var(--success-color);\n}\n\n.badge.green {\n  background: var(--success-color);\n}\n\n.badge.warning {\n  background: var(--warning-color);\n}\n\n/* Enhanced Forms */\nform {\n  space-y: 1rem;\n}\n\nform label {\n  display: flex;\n  flex-direction: column;\n  margin-bottom: 1rem;\n  font-size: 0.875rem;\n  font-weight: 500;\n  color: var(--text-primary);\n}\n\nform input,\nform select {\n  padding: 0.5rem;\n  border: 1px solid var(--border-color);\n  border-radius: var(--radius);\n  font-size: 0.875rem;\n  transition: all 0.2s ease;\n  background: white;\n  margin-top: 0.25rem;\n}\n\nform input:focus,\nform select:focus {\n  outline: none;\n  border-color: var(--primary-color);\n  box-shadow: 0 0 0 3px rgb(37 99 235 / 0.1);\n}\n\nform input:invalid {\n  border-color: var(--danger-color);\n}\n\n/* Enhanced Spinner */\n.spinner {\n  border: 3px solid #e5e7eb;\n  border-top: 3px solid var(--primary-color);\n  border-radius: 50%;\n  width: 1.5rem;\n  height: 1.5rem;\n  animation: spin 1s linear infinite;\n  margin: 2rem auto;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n/* Toast Notifications */\n.toast-container {\n  position: fixed;\n  top: 1rem;\n  right: 1rem;\n  z-index: 1000;\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.toast {\n  background: white;\n  border: 1px solid var(--border-color);\n  border-radius: var(--radius);\n  padding: 0.75rem;\n  box-shadow: var(--shadow-lg);\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  min-width: 300px;\n  animation: slideIn 0.3s ease;\n}\n\n.toast.success {\n  border-left: 4px solid var(--success-color);\n}\n\n.toast.error {\n  border-left: 4px solid var(--danger-color);\n}\n\n.toast.warning {\n  border-left: 4px solid var(--warning-color);\n}\n\n@keyframes slideIn {\n  from {\n    opacity: 0;\n    transform: translateX(100%);\n  }\n  to {\n    opacity: 1;\n    transform: translateX(0);\n  }\n}\n\n/* Status Indicators */\n.status-indicator {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.25rem;\n  padding: 0.125rem 0.5rem;\n  border-radius: 9999px;\n  font-size: 0.75rem;\n  font-weight: 500;\n}\n\n.status-indicator.active {\n  background: #dcfce7;\n  color: #166534;\n}\n\n.status-indicator.trial {\n  background: #fef3c7;\n  color: #92400e;\n}\n\n.status-indicator.expired {\n  background: #fef2f2;\n  color: #dc2626;\n}\n\n/* Enhanced Details/Summary */\ndetails.card {\n  border: 1px solid var(--border-color);\n  transition: all 0.2s ease;\n}\n\ndetails.card:hover {\n  border-color: var(--primary-color);\n}\n\ndetails summary {\n  cursor: pointer;\n  font-weight: 600;\n  color: var(--text-primary);\n  padding: 0.75rem 0;\n  border-bottom: 1px solid var(--border-color);\n  transition: color 0.2s ease;\n}\n\ndetails summary:hover {\n  color: var(--primary-color);\n}\n\ndetails[open] summary {\n  color: var(--primary-color);\n  border-bottom-color: var(--primary-color);\n}\n\n/* Selected Organization Indicator */\n.selected-org-info {\n  background: #eff6ff;\n  border: 1px solid #bfdbfe;\n  border-radius: var(--radius);\n  padding: 0.75rem;\n  margin-bottom: 1rem;\n  font-size: 0.875rem;\n  color: var(--text-primary);\n}\n\n/* User Tags */\n.user-tag {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.375rem 0.5rem;\n  background: white;\n  border: 1px solid var(--border-color);\n  border-radius: var(--radius);\n  font-size: 0.8rem;\n  transition: all 0.2s ease;\n  box-shadow: var(--shadow-sm);\n}\n\n.user-tag:hover {\n  box-shadow: var(--shadow-md);\n}\n\n.user-tag.owner-tag {\n  background: linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%);\n  border: 2px solid #1e3a8a;\n  box-shadow: 0 2px 8px rgba(30, 58, 138, 0.3);\n}\n\n.user-tag.owner-tag:hover {\n  box-shadow: 0 4px 12px rgba(30, 58, 138, 0.4);\n}\n\n.user-tag .role {\n  background: var(--secondary-color);\n  color: var(--text-secondary);\n  padding: 0.125rem 0.375rem;\n  border-radius: calc(var(--radius) * 0.5);\n  font-size: 0.7rem;\n  font-weight: 500;\n}\n\n.user-tag .role.owner-role {\n  background: linear-gradient(135deg, #1e3a8a 0%, #1e40af 100%);\n  color: white;\n  font-weight: 700;\n  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);\n  animation: subtle-pulse 2s ease-in-out infinite;\n}\n\n@keyframes subtle-pulse {\n  0%, 100% { transform: scale(1); }\n  50% { transform: scale(1.05); }\n}\n\n/* Pagination */\n.pagination {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 0.5rem;\n  margin-top: 1.5rem;\n  padding: 1rem;\n  background: var(--secondary-color);\n  border-radius: var(--radius);\n}\n\n.pagination button {\n  padding: 0.375rem 0.75rem;\n  border: 1px solid var(--border-color);\n  background: white;\n  border-radius: var(--radius);\n  font-size: 0.875rem;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.pagination button:hover:not(:disabled) {\n  background: var(--primary-color);\n  color: white;\n  border-color: var(--primary-color);\n}\n\n.pagination button:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n/* CTA Button */\n.cta-add-org {\n  display: block;\n  width: 100%;\n  margin-bottom: 1.5rem;\n  font-size: 0.875rem;\n  padding: 0.75rem;\n  background: var(--success-color);\n  border: none;\n  color: white;\n  border-radius: var(--radius);\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  box-shadow: var(--shadow-sm);\n}\n\n.cta-add-org:hover {\n  background: #047857;\n  box-shadow: var(--shadow-md);\n}\n\n/* Edit Name Inline */\n.edit-name-container {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.edit-name-input {\n  flex: 1;\n  padding: 0.25rem 0.5rem;\n  border: 1px solid var(--primary-color);\n  border-radius: var(--radius);\n  font-size: 0.875rem;\n}\n\n.edit-name-input:focus {\n  outline: none;\n  box-shadow: 0 0 0 2px rgb(37 99 235 / 0.2);\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .search-controls > div {\n    flex-direction: column;\n  }\n  \n  .org-table th,\n  .org-table td {\n    padding: 0.5rem;\n    font-size: 0.8rem;\n  }\n  \n  .user-tag {\n    font-size: 0.75rem;\n    padding: 0.25rem 0.375rem;\n  }\n  \n  .toast {\n    min-width: 250px;\n    margin: 0 1rem;\n  }\n}\n\n/* Animations */\n@keyframes fadeIn {\n  from { opacity: 0; transform: translateY(10px); }\n  to { opacity: 1; transform: translateY(0); }\n}\n\n.fade-in {\n  animation: fadeIn 0.3s ease;\n}\n\n/* Focus Visible for Accessibility */\nbutton:focus-visible,\ninput:focus-visible,\nselect:focus-visible {\n  outline: 2px solid var(--primary-color);\n  outline-offset: 2px;\n}\n\n/* Searchable Select Component */\n.searchable-select {\n  position: relative;\n  width: 100%;\n}\n\n.select-trigger {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0.5rem;\n  border: 1px solid var(--border-color);\n  border-radius: var(--radius);\n  background: white;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  font-size: 0.875rem;\n}\n\n.select-trigger:hover:not(.disabled) {\n  border-color: var(--text-secondary);\n}\n\n.select-trigger:focus {\n  outline: none;\n  border-color: var(--primary-color);\n  box-shadow: 0 0 0 3px rgb(37 99 235 / 0.1);\n}\n\n.select-trigger.open {\n  border-color: var(--primary-color);\n  box-shadow: 0 0 0 3px rgb(37 99 235 / 0.1);\n}\n\n.select-trigger.disabled {\n  background: var(--secondary-color);\n  color: var(--text-secondary);\n  cursor: not-allowed;\n}\n\n.select-value {\n  flex: 1;\n  text-align: left;\n  color: var(--text-primary);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.select-trigger.disabled .select-value {\n  color: var(--text-secondary);\n}\n\n.select-arrow {\n  color: var(--text-secondary);\n  font-size: 0.75rem;\n  transition: transform 0.2s ease;\n  margin-left: 0.5rem;\n}\n\n.select-trigger.open .select-arrow {\n  transform: rotate(180deg);\n}\n\n.select-dropdown {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  right: 0;\n  z-index: 1000;\n  background: white;\n  border: 1px solid var(--border-color);\n  border-radius: var(--radius);\n  box-shadow: var(--shadow-lg);\n  margin-top: 0.25rem;\n  overflow: hidden;\n}\n\n.select-search {\n  width: 100%;\n  padding: 0.5rem;\n  border: none;\n  border-bottom: 1px solid var(--border-color);\n  font-size: 0.875rem;\n  outline: none;\n}\n\n.select-search:focus {\n  border-bottom-color: var(--primary-color);\n}\n\n.select-options {\n  max-height: 200px;\n  overflow-y: auto;\n}\n\n.select-option {\n  padding: 0.5rem;\n  cursor: pointer;\n  transition: background-color 0.15s ease;\n  font-size: 0.875rem;\n  border-bottom: 1px solid var(--border-color);\n}\n\n.select-option:last-child {\n  border-bottom: none;\n}\n\n.select-option:hover,\n.select-option.highlighted {\n  background: var(--secondary-color);\n}\n\n.select-option.selected {\n  background: #eff6ff;\n  color: var(--primary-color);\n  font-weight: 500;\n}\n\n.select-option.no-options {\n  color: var(--text-secondary);\n  cursor: default;\n  font-style: italic;\n}\n\n.select-option.no-options:hover {\n  background: transparent;\n}\n\n/* Custom scrollbar for select options */\n.select-options::-webkit-scrollbar {\n  width: 6px;\n}\n\n.select-options::-webkit-scrollbar-track {\n  background: var(--secondary-color);\n}\n\n.select-options::-webkit-scrollbar-thumb {\n  background: var(--border-color);\n  border-radius: 3px;\n}\n\n.select-options::-webkit-scrollbar-thumb:hover {\n  background: var(--text-secondary);\n}\n\n/* Responsive adjustments for mobile */\n@media (max-width: 768px) {\n  .select-dropdown {\n    position: fixed;\n    left: 1rem;\n    right: 1rem;\n    top: auto;\n    bottom: auto;\n    max-height: 50vh;\n  }\n  \n  .select-options {\n    max-height: 40vh;\n  }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
